import maybe from '../../maybe'

const isOwned = kitOwnById => kit => !!(kit && kitOwnById && kitOwnById[kit.kitId])

const isWanted = kitWantById => kit => !!(kit && kitWantById && kitWantById[kit.kitId])

const updateKitOwn = (kitOwn, { own, kit }) => {
	const { kitId } = kit
	if (!kitId || (kitOwn && kitOwn.kitId !== kitId)) {
		return kitOwn
	}
	return !!own && { kitId }
}

const updateKitWant = (kitWant, { want, kit }) => {
	const { kitId } = kit
	if (!kitId || (kitWant && kitWant.kitId !== kitId)) {
		return kitWant
	}
	return !!want && { kitId }
}

// TODO: images: check usages of kit.image (e.g. the ownwant collections? or is is just here, the optimistic update?)
const updateKitsOwned = (kitsOwned, { own, kit }) => [...maybe([kit], own), ...kitsOwned.filter(k => k.kitId !== kit.kitId)]
const updateKitsWanted = (kitsWanted, { want, kit }) => [...maybe([kit], want), ...kitsWanted.filter(k => k.kitId !== kit.kitId)]

export default {
	isOwned,
	isWanted,
	updateKitOwn,
	updateKitWant,
	updateKitsOwned,
	updateKitsWanted
}



// WEBPACK FOOTER //
// ./src/utilities/Data/Kit/index.js